import { z } from 'zod';
import ky from 'ky';
import { ENV } from 'src/utils/env';
import { TASK_ACTION_MAP } from 'src/utils';
import { RESINGESTOR_BASE_SCHEMA } from '../_common';

const COPY_SCHEMA = RESINGESTOR_BASE_SCHEMA.pick({
  index1: true,
  index2: true,
  source1: true,
  sourcetype1: true,
  earliest1: true,
  latest1: true,
  latest2: true,
  email_address: true,
  only_positional: true,
}).extend({
  earliest2: z.string(),
});

const COPY_RESPONSE_SCHEMA = z.object({
  success: z.boolean(),
  task_id: z.string(),
});

export type CopySchema = z.infer<typeof COPY_SCHEMA>;

export const reingestorCopyPromise = async (params: CopySchema) => {
  const validatedParam = COPY_SCHEMA.safeParse(params);

  if (!validatedParam.success) {
    console.error(validatedParam.error);
    throw new Error('Invalid param');
  }

  const response = await ky
    .post(`${ENV.FRONTEND_API_URL}/reingestor`, {
      body: JSON.stringify({
        params: {
          ...validatedParam.data,
          action_type: TASK_ACTION_MAP.copy,
        },
      }),
    })
    .json();

  const validatedResponse = COPY_RESPONSE_SCHEMA.safeParse(response);

  if (!validatedResponse.success) {
    console.error(validatedResponse.error);
    return false;
  }

  return validatedResponse.data?.success;
};
